import ImagesUrl from "../../../assets/Index";

export const HrManagementData = [
    {   
        "id":1,
        // "imgUrl":ImagesUrl.Qkrtask.QkrtaskHeader,
        // "link":"/signup",
        // "title":"The Future of HRMS is Here",
        // "subTitle":"Best HR Software for SMEs",
        "title":"Best HR Software",
        "subTitle":"Streamline Your People <span className='text-magenta'>Management</span>",
        "headList":[
            {
                "li":"Smart HR Automation Made Easy"
            },
            {
                "li":"Fully Integrated Employee Field Tracking"
            },
            {
                "li":"HR Policies Made Simple, Compliance Made Certain"
            },
            {
                "li":"Your HR Command Center: From <span className='border-warning text-magenta fn-sb'>Dashboard to Doneboard</span>"
            },
            {
              "li":"One Click, Zero Complexity: HR Management Re-imagined"
          }
        ],
        "reting":[
            {
                "imgUrl":ImagesUrl.hrAdd.google,
                "desc":"Google",
                "cls":"fluid",
                "ratings":5
            },
            {
                "imgUrl":ImagesUrl.hrAdd.capterra,
                "desc":"Capterra",
                "cls":"fluid",
                "ratings":5

            },
            {
                "imgUrl":ImagesUrl.hrAdd.g2,
                "desc":"G2",
                "cls":"width-88",
                "ratings":5

            },
            {
                "imgUrl":ImagesUrl.hrAdd.softwareSuggest,
                "desc":"Software Suggest",
                "cls":"fluid",
                "ratings":5
            }
        ]
    }
];

export const KeyBenefits = [
    {
      head: "Key Benefits of <span className='text-pink'>QkrHR<span>",
      desc: "",
      keyCard: [
        {
          imgUrl: ImagesUrl.hrAdd.streamlinedHRProcesse,
          title: "Streamline HR Processes",
          listing: [
            "Automate payroll and attendance management.",
            "Centralize employee data for easy access.",
            "Reduce HR admin time by up to 40%.",
            "Get the numbers you need without waiting.",
          ],
        },
        {
          imgUrl: ImagesUrl.hrAdd.boostedEmployee,
          title: "Boost Employee Engagement",
          listing: [
            "Self-service portal for employees.",
            "Foster transparency with instant communication.",
            "Personalized dashboards for every role.",
            "Celebrate achievements with employee recognition features.",
          ],
        },
        {
          imgUrl: ImagesUrl.hrAdd.customizableScalable,
          title: "Customizable & Scalable",
          listing: [
            "Adaptable modules for unique workflows.",
            "Seamlessly scale your team.",
            "Flexible pay-per-use pricing.",
            "Custom reports and dashboards.",
          ],
        },
        {
          imgUrl: ImagesUrl.hrAdd.ImprovedWorkforce,
          title: "Improve Productivity",
          listing: [
            "Automate routine tasks to reduce errors.",
            "Employee self-service for quick requests.",
            "Stay on top of changes as they happen.",
            "Improve team collaboration.",
          ],
        },
      ],
    },
];

export const WhyChooseQkrHR = [
    {
        "title":"Why Choose QkrHR?",
        "subTitle":"QkrHR vs Traditional HRMS:",
        TableHead:[
            {
                th:'Feature',
            },
            {
                th:'QkHR',
            },
            {
                th:'Traditional HRMS',
            }
        ],
        Tablebody:[
            {
                td1:'Focus',
                td2:'Employee centric design with emphasis on user experience and accessibility.',
                td3:'Process-centric approach focusing on administrative workflows.',
             },
             {
                td1:'User Experience',
                td2:'Modern intuitive interface with minimal training required.',
                td3:'Complex interfaces require extensive training and documentation.',
             },
             {
                td1:'Smart Automation',
                td2:'Highly configurable with dynamic workflow adaptation.',
                td3:'Rigid and outdated; Lacks flexibility for modern needs.',
             },
             {
                td1:'Policy Transparency',
                td2:'Clear policy documentation and updates with realtime notification.',
                td3:'Policies are often buried in complex menus with delayed updates.',
             },
             {
                td1:'Customization',
                td2:'Flexible configurable options.',
                td3:'Limited customization requiring technical expertise or vendor support.',
             },
             {
                td1:'Field Force Automation',
                td2:'Seamlessly manage both office and field employees from a single platform.',
                td3:'Limited functionality for managing field employees; often requires separate tools.',
             },
             {
                td1:'Intelligent Navigation',
                td2:'All critical data in one place, no multi-screen hopping needed.',
                td3:'Scattered data requiring multiple screen navigation.',
             },
             {
                td1:'Device Flexibility',
                td2:'Seamless functionality across all devices - from smartphones to tablets to desktops.',
                td3:'Desktop-centric design with limited mobile capabilities.',
             }
        ]
    }  
]

export const WhyChooseQkrHRs = [
    {
        "title":"Why Choose QkrHR?",
        "subTitle":"QkrHR vs Traditional HRMS:",
        TableHead:[
            {
                th:'Feature',
                width:20
            },
            {
                th:'QkHR',
                width:40
            },
            {
                th:'Traditional HRMS',
                width:40
            }
        ],
        Tablebody:[
            {
                td1:'Focus',
                td2:'Employee centric design with emphasis on user experience and accessibility.',
                td3:'Process-centric approach focusing on administrative workflows.',
             },
             {
                td1:'User Experience',
                td2:'Modern intuitive interface with minimal training required.',
                td3:'Complex interfaces require extensive training and documentation.',
             },
             {
                td1:'Smart Automation',
                td2:'Highly configurable with dynamic workflow adaptation.',
                td3:'Rigid and outdated; Lacks flexibility for modern needs.',
             },
             {
                td1:'Policy Transparency',
                td2:'Clear policy documentation and updates with realtime notification.',
                td3:'Policies are often buried in complex menus with delayed updates.',
             },
             {
                td1:'Customization',
                td2:'Flexible configurable options.',
                td3:'Limited customization requiring technical expertise or vendor support.',
             },
             {
                td1:'Field Force Automation',
                td2:'Seamlessly manage both office and field employees from a single platform.',
                td3:'Limited functionality for managing field employees; often requires separate tools.',
             },
             {
                td1:'Intelligent Navigation',
                td2:'All critical data in one place, no multi-screen hopping needed.',
                td3:'Scattered data requiring multiple screen navigation.',
             },
             {
                td1:'Device Flexibility',
                td2:'Seamless functionality across all devices - from smartphones to tablets to desktops.',
                td3:'Desktop-centric design with limited mobile capabilities.',
             }
        ]
    },
      {
         td1:'Focus',
         td2:'Employee centric design with emphasis on user experience and accessibility.',
         td3:'Process-centric approach focusing on administrative workflows.',
      },
      {
         td1:'User Experience',
         td2:'Modern intuitive interface with minimal training required.',
         td3:'Complex interfaces require extensive training and documentation.',
      },
      {
         td1:'Smart Automation',
         td2:'Highly configurable with dynamic workflow adaptation.',
         td3:'Rigid and outdated; Lacks flexibility for modern needs.',
      },
      {
         td1:'Policy Transparency',
         td2:'Clear policy documentation and updates with realtime notification.',
         td3:'Policies are often buried in complex menus with delayed updates.',
      },
      {
         td1:'Customization',
         td2:'Flexible configurable options.',
         td3:'Limited customization requiring technical expertise or vendor support.',
      },
      {
         td1:'Field Force Automation',
         td2:'Seamlessly manage both office and field employees from a single platform.',
         td3:'Limited functionality for managing field employees; often requires separate tools.',
      },
      {
         td1:'Intelligent Navigation',
         td2:'All critical data in one place, no multi-screen hopping needed.',
         td3:'Scattered data requiring multiple screen navigation.',
      },
      {
         td1:'Device Flexibility',
         td2:'Seamless functionality across all devices - from smartphones to tablets to desktops.',
         td3:'Desktop-centric design with limited mobile capabilities.',
      }
   
]

export const AllInOneHRMS = [
    { 
      id: 1,
      title:"All-in-One <span className='text-pink'>HRMS Software</span>",
      desc:"",
      AllTabData:[
          {
            id: 1,
            tabName: "Core HR",
            tabIcon: "core-hr-tab",
            navList: [
              {
                videoUrl: "",
                imgUrl : ImagesUrl.hrAdd.coreHR,
                alt:"Core HR",
                title:"Core HR",
                videoAuto: true,
              }
            ],
            "active": true,
          },
          // {
          //   id: 2,
          //   tabName: "Field Employee Tracking",
          //   tabIcon: "field-employee-tracking",
          //   navList: [
          //     {
          //       videoUrl:"",
          //       imgUrl : ImagesUrl.hrAdd.fieldEmployeeTracking,
          //       alt:"Field Employee Tracking",
          //       title:"Field Employee Tracking",
          //       videoAuto: false,
          //     }
          //   ],
          //   active: true,
          // },
          {
            id: 3,
            tabName: "Time & Attendance",
            tabIcon: "time-attendance",
            navList: [
              {
                videoUrl:"",
                imgUrl : ImagesUrl.hrAdd.timeAttendance,
                alt:"Time & Attendance",
                title:"Time & Attendance",
                videoAuto: false,
              }
            ],
            active: false,
          },
          {
            id: 4,
            tabName: "Payroll",
            tabIcon: "payroll",
            navList: [
              {
                videoUrl: "",
                imgUrl : ImagesUrl.hrAdd.payroll,
                alt:"Payroll",
                title:"Payroll",
                videoAuto: true,
              }
            ],
            active: false,
          },
          // {
          //   id: 5,
          //   tabName: "Expense Management",
          //   tabIcon: "expense-management",
          //   navList: [
          //     {
          //       videoUrl: "",
          //       imgUrl : ImagesUrl.hrAdd.expenseManagement,
          //       alt:"Expense Managemen",
          //       title:"Expense Management",
          //       videoAuto: true,
          //     }
          //   ],
          //   active: false,
          // },
          {
            id: 5,
            tabName: "Employee Engagement",
            tabIcon: "employee-engagement",
            navList: [
              {
                videoUrl: "",
                imgUrl : ImagesUrl.hrAdd.employeeEngagement,
                alt:"Employee Management",
                title:"Employee Management",
                videoAuto: true,
              }
            ],
            active: false,
          }
      ]
    }
];

export const SimplifyingHR = {
  hero: {
    title: {
      main: "QkrHR:",
      highlight: "<span className='text-pink'>Simplifying HR, Amplifying Impact</span>"
    },
    subtitle: "Transform your HR operations with smart automation that simplifies processes and drives growth",
    ctaButton: {
      text: "Request Demo",
    }
  },
  features: [
    {
      type: "For Employee",
      icon: "employee-icon",
      className: "feature-card top",
      items: [
        "HR Services at Your Fingertips",
        "Your HR Experience, Simplified",
        "Access Everything HR, Effortlessly"
      ]
    },
    {
      type: "For Manager",
      icon: "manager-icon",
      className: "feature-card",
      items: [
        "Clarity Drives Better Decisions",
        "Lead with Insight, Not Paperwork",
        "Streamlined Management, Enhanced Results"
      ]
    },
    {
      type: "For HR",
      icon: "hr-icon",
      className: "feature-card bottom",
      items: [
        "Automate the Routine, Focus on What Matters",
        "Smart Automation for Modern HR Teams",
        "End Manual Follow-ups Forever"
      ]
    }
  ]
};
export const FieldEmployeeTracking =[
  {
    "id": 1,
    "title": "Field Employee Tracking",
    "heading": "Track, Manage & Optimize Your Field Workforce",
    "description": "QkrHR's field employee tracking solution helps businesses increase productivity, reduce costs, and enhance customer satisfaction through real-time location tracking and automated attendance.",
    "imgUrl": ImagesUrl.hrAdd.fieldEmployeeTracking,
  }
]
export const ElevateHrManagement =[
  {
    "key": "1",
    "icon1":"faRemove",
    "icon2":"faCheck",
    "problem": "Complex, Fragmented Systems",
    "solution": "One Unified Platform",
    "description": "QkrHR centralizes attendance, leave management, field employee tracking, and employee data in one intuitive interface",
    "benefit": "Save 15+ hours weekly on HR tasks"
  },
  {
    "key": "2",
    "icon1":"faRemove",
    "icon2":"faCheck",
    "problem": "Manual Data Entry",
    "solution": "Automated Workflows",
    "description": "Automate attendance tracking and leave approvals with just one click",
    "benefit": "Reduce processing time by 75%"
  },
  {
    "key": "3",
    "icon1":"faRemove",
    "icon2":"faCheck",
    "problem": "Scattered Employee Information",
    "solution": "Centralized Database",
    "description": "Access all employee information instantly from our secure central database",
    "benefit": "100% data accuracy"
  },
  {
    "key": "4",
    "icon1":"faRemove",
    "icon2":"faCheck",
    "problem": "Limited Accessibility",
    "solution": "Anytime, Anywhere Access",
    "description": "Access HR data securely from any device, anywhere, anytime",
    "benefit": "24/7 system availability"
  },
  {
    "key": "5",
    "icon1":"faRemove",
    "icon2":"faCheck",
    "problem": "High Operational Costs",
    "solution": "Cost-Effective Solution",
    "description": "Eliminate paperwork and reduce administrative overhead",
    "benefit": "Cut HR operational costs by 40%"
  },
  {
    "key": "6",
    "icon1":"faRemove",
    "icon2":"faCheck",
    "problem": "Error-Prone Processes",
    "solution": "Smart Automation",
    "description": "Eliminate manual errors with automated validation and verification",
    "benefit": "Reduce errors by up to 95% in HR processes"
  }
];

export const RevolutionizeYourHR = [
  {
    // title:'Revolutionize Your HR Operations with QkrHR – &nbsp; <span className="navbar-brand qkr-hr"></span>',
    title:'Revolutionize Your HR Operations with QkrHR',
    desc:"Streamline processes, boost employee engagement, and drive exceptional performance with our all-in-one HR platform- QkrHR",
    AllClients:[
      {
          title:"200+",
          desc:"Companies",
      },
      {
          title:"20,000+",
          desc:"Users",
      },
      {
          title:"98%",
          desc:"Satisfaction Rate",
      }
    ]
  }
];

export const UnmatchedFeatures = [
  {
    title:"Unmatched <span className='text-pink'>Features</span>",
    desc:"",
    AllClients:[
      {  
          cls:"bg-pink-lights",
          title:"Complete HR Suite",
          desc:9.8,
      },
      {
          cls:"bg-warning-lights",
          title:"Smart Insights",
          desc:9.8,
      },
      {
          cls:"bg-success-lights",
          title:"Instant Help",
          desc:9.7,
      },
      {
          cls:"bg-slateblue-lights",
          title:"Quick Implementation",
          desc:9.8,
      },
      {
          cls:"bg-magenta-lights",
          title:"Field Force Integration",
          desc:9.7,
      },
      {
          cls:"bg-danger-lights",
          title:"Mobile First Solution",
          desc:9.8,
      }
    ]
  }
];

export const ElevateHR = [
  {
    
    id:1,
    title:"Elevate HR,",
    subTitle:"HR Solutions That Drive Business Excellence",
    imgUrl:ImagesUrl.clientDetail.clientsPranavGoel,
    desc:`QkrHR's highly integrated Field Force Management has made managing office and field teams seamless, boosting overall productivity.`,
    clientName:"Pranav Goel",
    companyName:"CEO DebtSet",
    ratings:5,
  },
  {   
      id:2,
      title:"Elevate HR,",
      subTitle:"One Click at a Time",
      imgUrl:ImagesUrl.clientDetail.clientsAshok_jade,
      desc:`QkrHR transformed how we handle our HR operations. What used to take days now takes minutes. It's like having an extra team member dedicated to HR.`,
      clientName:"Ashok Jade.",
      companyName:"CEO, Shalimar paints",
      ratings:5,
  },
  {   
      id:3,
      title:"Elevate HR,",
      subTitle:"HR Excellence in One Platform",
      imgUrl:ImagesUrl.clientDetail.clientsDinesh_gupta,
      desc:`The scalability of QkrHR has been a game-changer. As we've grown from 50 to 200 employees, the platform has grown seamlessly with us.`,
      clientName:"Dinesh C. Gupta",
      companyName:"HR Director, Capital Power System Ltd.",
      ratings:4,
  },
  {   
    id:4,
    title:"Elevate HR,",
    subTitle:"HRMS That Works While You Thrive",
    imgUrl:ImagesUrl.clientDetail.clientsRanjit_singh,
    desc:`Implementing QkrHR was the best decision we made for our growing business. The ROI is clear - we've cut HR administrative time by 70%.`,
    clientName:"Ranjith Singh.",
    companyName:"Vice President, Arihant Electricals Pvt. Ltd",
    ratings:5,
  },
  {   
    id:5,
    title:"Elevate HR,",
    subTitle:"People Management Made Effortless",
    imgUrl:ImagesUrl.clientDetail.clientsAtal_vihari,
    desc:`What impressed me most about QkrHR is how intuitive it is. Our team needed minimal training, and now they can't imagine working without it.`,
    clientName:"Atal Bihari",
    companyName:"Sales Head, Vision Plus Pvt.Ltd.",
    ratings:5,
  }
];

export const ReadyToTransform = [
  { 
    imgUrl:ImagesUrl.hrAdd.hrOperations1,
    title:"Ready to Transform Your </br><span className='text-pink'>HR Operations</span>",
    desc:"Book a demo today and discover how QkrHR can revolutionize your HR management with clarity, efficiency, and intelligence."
  },
  {
    imgUrl:ImagesUrl.hrAdd.hrOperations2,
    title:"Ready to Experience </br><span className='text-pink'>HR Without Complexity?</span>",
    desc:"Book a demo today and discover how QkrHR empowers your team with automated workflows and crystal-clear insights."
  },
  {
    imgUrl:ImagesUrl.hrAdd.hrOperations3,
    title:"Looking for HR That </br><span className='text-pink'>Works Like You Do?</span>",
    desc:"Book a demo today and see how QkrHR transforms your HR operations with familiar tools and powerful automation."
  },
  {
    imgUrl:ImagesUrl.hrAdd.hrOperations4,
    title:"Want HR Management That </br><span className='text-pink'>Moves at Your Speed?</span>",
    desc:"Book a demo today and explore how QkrHR puts complete HR control at your fingertips, anywhere, anytime."
  },
];

export const FaqAdvertise = [
  {
   id:1,
   title:"Frequently Asked Questions",
   desc:"Haven't got your answer? <span className='text-pink'>Contact our support now<span>",
   List:[
      {
        id:1,
        title:"What is QkrHR and how does it differ from traditional HR systems?",
        desc:"QkrHR is a modern HR management platform that focuses on informed decision-making rather thanjust completing functionalities. Unlike traditional systems, we prioritize clarity and user experience,offering hassle-free access to policies and automated workflows that actually make sense.",
      },
      {
        id:2,
        title:"Does QkrHR include Field employee tracking?",
        desc:'Yes, QkrHR includes field employee tracking. This feature lets you monitor location, hours, and activities of employees working outside the office in real-time.'
      },
      {
        id:3,
        title:"Is QkrHR best suitable for SME'S?",
        desc:"Yes, QkrHR is ideally suited for SMEs. Its scalable features, cost-effective pricing structure, and streamlined functionality make it particularly valuable for small and medium enterprises seeking robust HR management without enterprise-level complexity or expense."
      },
      {
        id:4,
        title:"How easy is it to implement QkrHR?",
        desc:"Setting up QkrHR is simple and quick. Our team helps you move your data, set up the system, and train your staff. Most companies start using it fully within a few weeks, depending on how complex your HR needs are."
      },
      // {
      //   id:5,
      //   title:"Can QkrHR integrate with our existing software systems? ",
      //   desc:"Yes, QkrHR offers seamless integration with most popular business software including payroll systems, time tracking tools, and communication platforms. Our API allows for custom integrations as needed."
      // },
      // {
      //     id:6,
      //     title:"What are the 5 key functions of Core HR in HRMS Software?",
      //     desc:"<h4 className='mb-3'>Top 5 functions of Core HR</h4>"
      //     +"<ul className='ul-icon'>"
      //         +"<li className='tick-icon-magenta'>Employee database management</li>"
      //         +"<li className='tick-icon-magenta'>Payroll processing and administration</li>"
      //         +"<li className='tick-icon-magenta'>Time and attendance tracking</li>"
      //         +"<li className='tick-icon-magenta'>Benefits administration</li>"
      //         +"<li className='tick-icon-magenta'>Compliance and reporting</li>"
      //     +"</ul>"     
      // }
    ]
  }
]